import { render, staticRenderFns } from "./ifmLishihui.vue?vue&type=template&id=34ab13c9&scoped=true"
import script from "./ifmLishihui.vue?vue&type=script&lang=js"
export * from "./ifmLishihui.vue?vue&type=script&lang=js"
import style0 from "./ifmLishihui.vue?vue&type=style&index=0&id=34ab13c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ab13c9",
  null
  
)

export default component.exports